<div class="modal-header">
    <h5 class="modal-title" id="editDiscountTitle">{{headerText}}</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="perkForm">
      <div class="row">
          <div class="col-md-8 mb-3">
              <label for="discountValue" class="form-label">Value</label>
              <input formControlName="value" placeholder=""  type="text" class="form-control" id="discountValue" placeholder="value">
          </div>
          <div class="col-md-4 mb-3">
              <label for="discountLimit" class="form-label">Redemption Limit</label>
              <input formControlName="limit" type="number" class="form-control" id="discountLimit" placeholder="limit">
          </div>
      </div>
      <div class="row">
          <div class="col-md-6 mb-3">
              <label for="discountStart" class="form-label">Start Date</label>
              <mbsc-datepicker min="now" formControlName="startDate" returnFormat="iso8601" select="date"></mbsc-datepicker>
          </div>
          <div class="col-md-6 mb-3">
              <label for="discountEnd" class="form-label">End Date</label>
              <mbsc-datepicker min="now" formControlName="endDate" returnFormat="iso8601" select="date"></mbsc-datepicker>
            </div>
      </div>
      </form>
  </div>
  <div class="modal-footer">
      <button type="button" class="btn btn-sb border-lb text-strong text-uppercase m-100" (click)="save()">Save</button>
        <button type="button" class="btn btn-cancel text-strong text-uppercase m-100" (click)="dismiss()">Cancel</button>
  </div>